import type { BookingLifecycleStatus } from "@/types";

/** Non-terminal statuses selected by default on the partner bookings list. */
export const DEFAULT_ACTIVE_BOOKING_STATUSES: readonly BookingLifecycleStatus[] =
  ["CREATED", "PENDING_HANDSHAKE", "ACCEPTED"];

export const BOOKING_STATUS_FILTER_OPTIONS: readonly BookingLifecycleStatus[] = [
  "CREATED",
  "PENDING_HANDSHAKE",
  "ACCEPTED",
  "COMPLETED",
  "CANCELED",
  "REJECTED",
  "ABANDONED",
];

export function isDefaultActiveStatusSelection(
  selected: readonly BookingLifecycleStatus[],
): boolean {
  if (selected.length !== DEFAULT_ACTIVE_BOOKING_STATUSES.length) {
    return false;
  }
  return DEFAULT_ACTIVE_BOOKING_STATUSES.every((status) =>
    selected.includes(status),
  );
}

export function isBookingStatusFilterNarrowed(
  selected: readonly BookingLifecycleStatus[],
): boolean {
  return !isDefaultActiveStatusSelection(selected);
}
